<script setup>
import { computed, ref } from "vue"

import Layout from "../../layouts/main.vue"
import PageHeader from "@/components/page-header"

import store from "../../state/store"
import ValueModal from "./ValueModal.vue"
import ValueEditModal from "./ValueEditModal.vue"
import ValuesTable from "./ValuesTable.vue"

const title = "مدیریت مقدار ویژگی ها"
const items = ref([
  {
    text: "داشبورد",
    href: "/",
  },
  {
    text: "مدیریت مقدار ویژگی ها",
    active: true,
  },
])

const DEFAULT_VALUE = {
  id: "",
  attribute_id: "",
  value_name: "",
}

const attributesNoPagination = computed(() => store.state.attributesNoPagination)

const valueModel = ref({ ...DEFAULT_VALUE })
const showValueModal = ref(false)
const showValueEditModal = ref(false)

const showAddNewModal = () => {
  showValueModal.value = true
}

const showEditModal = () => {
  showValueEditModal.value = true
}

function editValue(val) {
  store.dispatch("getValue", val.id).then(({ data }) => {
    valueModel.value = data.data
    showEditModal()
  })
}

const onModalClose = () => {
  valueModel.value = { ...DEFAULT_VALUE }
}
</script>

<template>
  <Layout>
    <PageHeader :title="title" :items="items" />
    <b-row>
      <b-col lg="12">
        <b-card no-body id="valueList">
          <b-card-header class="border-bottom-dashed">
            <b-row class="g-4 align-items-center">
              <b-col sm>
                <div>
                  <h5 class="card-title mb-0">لیست مقدار های ویژگی ها</h5>
                </div>
              </b-col>
              <b-col sm="auto">
                <div class="d-flex flex-wrap align-items-start gap-2">
                  <b-button
                    type="button"
                    variant="success"
                    class="add-btn me-1"
                    id="create-btn"
                    @click="showAddNewModal()"
                  >
                    <i class="ri-add-line align-bottom me-1"></i> افزودن مقدار
                    ویژگی جدید
                  </b-button>
                </div>
              </b-col>
            </b-row>
          </b-card-header>

          <!-- values table  -->

          <ValuesTable @clickEdit="editValue" />

          <!-- add and edit value modal  -->

          <ValueModal
            v-model="showValueModal"
            :value="valueModel"
            :attributes="attributesNoPagination"
            @close="onModalClose"
          />

          <ValueEditModal
            v-model="showValueEditModal"
            :value="valueModel"
            :attributes="attributesNoPagination"
            @close="onModalClose"
          />
        </b-card>
      </b-col>
    </b-row>
  </Layout>
</template>

<style>
.multiselect-clear {
  padding: 0 0 0 var(--ms-px, 0.875rem) !important;
}
.multiselect-caret {
  margin: 0 0 0 var(--ms-px, 0.875rem) !important;
}

.form-select {
  display: block;
  width: 100%;
  padding: 0.5rem 0.9rem 0.5rem 2.7rem !important;
  background-position: left 0.9rem center !important;
}

.invalid-feedback {
  display: block !important;
}
</style>
